import { ReactNode } from 'react';

import { Modal } from '../Modal/Modal';
import { SheetModal } from '../SheetModal/SheetModal';
import { SheetModalHeader } from '../SheetModal/SheetModalHeader';
import { Logo, LogoWatermark } from './style';
import { NotificationLayout } from '../../layouts/notification/NotificationLayout';
import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';
import { useIsMobile } from '../../hooks/useIsMobile';

export interface NotificationPageProps {
	prepend?: ReactNode;
	title?: string;
	children?: ReactNode;
}

export function NotificationPage({ children, prepend, title }: NotificationPageProps) {
	const theme = useThemeContext();
	const isMobile = useIsMobile();

	return (
		<NotificationLayout>
			<LogoWatermark>
				<Logo src={theme.logo} />
			</LogoWatermark>
			{isMobile && (
				<SheetModal
					isOpen={true}
					disableDrag={true}
					header={<SheetModalHeader prepend={prepend} title={title} />}
				>
					{children}
				</SheetModal>
			)}
			{!isMobile && (
				<Modal
					show={true}
					$fitToChildren={true}
					title={title}
					prepend={prepend}
					closeDisabled={true}
				>
					{children}
				</Modal>
			)}
		</NotificationLayout>
	);
}
